// Configurable Lite-ATS apply-form catalog. Keep keys in sync with the backend
// (recruiter-service app/services/prescreen_form.py). The recruiter toggles
// fields/documents per job; enabled ones render on the public apply page.

export type ApplyFieldMode = 'optional' | 'required';

export interface ApplyFormConfig {
  fields?: Record<string, ApplyFieldMode>;
  documents?: Record<string, ApplyFieldMode>;
}

export interface ApplyFieldDef {
  key: string;
  type: 'text' | 'number';
  de: string;
  en: string;
  placeholderDe?: string;
  placeholderEn?: string;
}

export interface ApplyDocDef {
  key: string;
  de: string;
  en: string;
}

export const APPLY_FIELDS: ApplyFieldDef[] = [
  { key: 'availability', type: 'text', de: 'Verfügbar ab', en: 'Available from', placeholderDe: 'z. B. ab sofort / 01.09.', placeholderEn: 'e.g. immediately / Sep 1' },
  { key: 'preferred_location', type: 'text', de: 'Bevorzugter Standort', en: 'Preferred location', placeholderDe: 'z. B. München / Remote', placeholderEn: 'e.g. Munich / Remote' },
  { key: 'university', type: 'text', de: 'Hochschule / Universität', en: 'University' },
  { key: 'study_program', type: 'text', de: 'Studiengang', en: 'Study program' },
  { key: 'study_semester', type: 'number', de: 'Fachsemester', en: 'Semester' },
  { key: 'school', type: 'text', de: 'Schule', en: 'School' },
  { key: 'grade_level', type: 'text', de: 'Klassenstufe', en: 'Grade / year' },
];

export const APPLY_DOCUMENTS: ApplyDocDef[] = [
  { key: 'enrollment_certificate', de: 'Studienbescheinigung', en: 'Enrollment certificate' },
  { key: 'transcript', de: 'Notenübersicht / Zeugnis', en: 'Transcript' },
  { key: 'school_report', de: 'Zeugnis (Schule)', en: 'School report' },
];

export interface ApplyPreset {
  label: string;
  fields: string[];
  documents: string[];
}

// Presets pre-toggle a sensible set so recruiters don't configure each field.
export const APPLY_PRESETS: Record<'students' | 'pupils', ApplyPreset> = {
  students: {
    label: 'Für Studierende',
    fields: ['availability', 'preferred_location', 'university', 'study_program', 'study_semester'],
    documents: ['enrollment_certificate'],
  },
  pupils: {
    label: 'Für Schüler:innen',
    fields: ['availability', 'preferred_location', 'school', 'grade_level'],
    documents: ['school_report'],
  },
};

export const fieldLabel = (def: ApplyFieldDef | ApplyDocDef, isDe: boolean): string =>
  isDe ? def.de : def.en;

export const enabledCount = (cfg: ApplyFormConfig | null | undefined): number => {
  if (!cfg) return 0;
  return Object.keys(cfg.fields || {}).length + Object.keys(cfg.documents || {}).length;
};
